import { Button } from "./components/ui/button";

import {BackgroundBoxesDemo} from './components/ui/Header'
import Section from "./components/ui/Section";
import Nav from "./components/ui/Nav";
import Projects from "./components/ui/Projects";
import Contact from "./components/ui/Contact";
function App() {
  return (
   
     <div className="App w-full h-full">
      <div className="flex flex-col gap-[20px] justify-center items-center">
   <Nav></Nav>
    <BackgroundBoxesDemo></BackgroundBoxesDemo>
    <div className="flex flex-col gap-[100px]">
 <Section/>

<Projects/>
<Contact/>
 </div>

      </div>
      
  
    </div>
 
   
  );
}

export default App;
